import { Meta, StoryObj } from '@storybook/react';

import { Icon } from './Icon';

const meta: Meta<typeof Icon> = {
  title: 'parts/decoration/Icon',
  component: Icon,
  args: {
    name: 'spot',
    addClass: [],
  },
};

export default meta;

type Story = StoryObj<typeof Icon>;

export const Basic: Story = {
  render: args => <Icon {...args} />,
};
